import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  sidebar: {
    maxWidth: 340,
    marginTop: 50,
    padding: '30px 30px 40px',
    backgroundColor: palette.common.white,
  },
  sidebarHeading: {
    marginBottom: 25,
    fontSize: 14,
  },
}));
